import React from "react";

export {WAMTBPSuccess};

const WAMTBPSuccess = (props: any) => {
  
  return(<></>);
};